module.exports = __webpack_public_path__ + "static/media/pills22x.26f3feff.png";